import type { ReadonlyDeep, SimplifyDeep } from 'type-fest';
import { z } from 'zod';

import { RawUIFolderSchema } from './raw-ui-folder';
import { allowVariablePlaceholders } from './raw-variable-placeholder';

export type RawJobConfig = SimplifyDeep<
  ReadonlyDeep<z.infer<typeof RawJobConfigSchema>>
>;

export const createRawJobConfigSchema = (allowVariables = false) => {
  return allowVariablePlaceholders(
    z.object({
      name: z.string(),
      schedule: z.string().optional(),
      resource: z.string().optional(),
      method: z.string().optional(),
      command: z.record(z.string(), z.unknown()).optional(),
      log_configuration: z
        .object({
          level: z.enum(['error', 'warn', 'debug', 'info']).optional(),
        })
        .optional()
        .nullable(),
      disabled: z.boolean().optional(),
      notes: z.string().optional(),
      ui_folder: RawUIFolderSchema.optional(),
    }),
    allowVariables
  ).passthrough();
};

export const RawJobConfigSchema = createRawJobConfigSchema();
